import { useState } from "react";
import React from "react";
import axios from "axios";



export const Contact = ({data}) => {
  const {contactData, servicesData = [] } = data

  const initialState = {
    service: "",
    contact: '',
    social: "Telegram",
    message: "",
    platformLabel: `Telegram`
  };

  const [{ service, contact, social, message, platformLabel }, setState] = useState(initialState);
  const [isDataSent, setIsDataSent] = useState(false);
  const [isDataProcessing, setIsDataProcessing] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const dataToUpdate = {[name]: value }
    if(name === 'social'){
      dataToUpdate.platformLabel = `${value}`
    }
    setState((prevState) => ({ ...prevState, ...dataToUpdate }));
    setIsDataProcessing(false)
    setIsDataSent(false)
  };
  const clearState = () => setState({ ...initialState });
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsDataProcessing(true)
    

    await axios.post('https://us-central1-landing-296f8.cloudfunctions.net/sendToTelegram',{ social, contact, service, message })

    clearState()
    setIsDataProcessing(false)
    setIsDataSent(true)
    
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>{contactData?.title}</h2>
                <p>
                {contactData?.description}
                </p>
              </div>
              <form name="sentMessage" onSubmit={handleSubmit} style={{textAlign:'center'}}>
                  
                  <label>{contactData?.questions[0] || ''}</label>
                  <div className="form-group">
                    <select
                      id="social"
                      name="social"
                      className="form-control"
                      required
                      value={social}  // Controlled component
                      onChange={handleChange}
                      style={{ borderRadius: 10, borderRight: '16px solid transparent' }}
                    >
                      {contactData?.contactOptions.map(option => 
                        <option key={option} value={option}>{option}</option>
                      )}
                    </select>
                    <p className="help-block text-danger"></p>
                  </div>
                  
                  <label>{platformLabel}</label>
                
                    <div className="form-group">
                      <input
                        type="text"
                        id="contact"
                        name="contact"
                        value={contact}
                        className="form-control"
                        placeholder={platformLabel}
                        required
                        onChange={handleChange}
                        style={{borderRadius:10}}
                      />
                      <p className="help-block text-danger"></p>
                    </div>

                    <div className="form-group">
                      <label>{contactData?.questions[2]|| ''}</label>
                      <select
                        id="service"
                        name="service"
                        defaultValue={servicesData[0]?.name || ''}  // initial value
                        className="form-control"
                        required
                        onChange={handleChange}
                        style={{borderRadius:10, borderRight: '16px solid transparent'}}
                      >
                        {servicesData.map(option => 
                          <option key={option.name} value={option.name}>{option.name}</option>
                        )}
                      </select>
                    </div>
                   

                  
                  <label>{contactData?.questions[3]|| ''}</label>
                  
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder={contactData?.questions[3]|| ''}
                    value={message}
                    required
                    onChange={handleChange}
                    style={{borderRadius:10}}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" disabled={isDataSent}  className="btn btn-custom btn-lg" style={{width:'320px'}}>
                  {(isDataProcessing)?
                    <div className="spinner-border text-light" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    :
                    (isDataSent)? contactData?.buttonSent: contactData?.button
                  }
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>{contactData?.title2}</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> {contactData?.addressTitle}
                </span>
                <a href="https://www.google.com/maps?q=Srebrna+16,+Warszawa" target="_blank" rel="noreferrer" style={{color:'white', textDecoration:'underline'}}>{contactData ? contactData.address : "loading"}</a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> {contactData?.phoneTitle}
                </span>{" "}
                <a href="tel:+48570557581" style={{color:'white', textDecoration:'underline'}}>{contactData ?contactData.phone : "loading"}</a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> {contactData?.emailTitle}
                </span>{" "}
                <a href="mailto:arilegalpl@gmail.com"  style={{color:'white', textDecoration:'underline'}}>{contactData ? contactData.email : "loading"}</a>

              </p>
            </div>
            <div className="contact-item">
              
                <span>
                  <i className="fa-solid fa-building"></i> {contactData?.companyTitle}
                </span>{" "}
                <p>{contactData ? contactData.company.name : "loading"}</p>
                <p>NIP: {contactData ? contactData.company.nip : "loading"}</p>
                <p>REGON: {contactData ? contactData.company.regon : "loading"}</p>

              
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={contactData ? contactData.instagram : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={contactData ? contactData.tiktok : "/"} target="_blank" rel="noreferrer">
                      <i className="fa-brands fa-tiktok"></i>
                    </a>
                  </li>
                  <li>
                    <a href={contactData ? contactData.instagram2 : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href={contactData ? contactData.facebook : "/"} target="_blank" rel="noreferrer">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
